import { BASE_URL } from "../constants/constants";
import AuthUtils from "../auth/AuthUtils";
export class AssetsService {
  public async getAssets(companyId: any) {
    try {
      let response = await fetch(`${BASE_URL}/assets/company/${companyId}`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }
  public async getAsset(fileName: any) {
    try {
      let response = await fetch(`${BASE_URL}/assets/resource`, {
        method: "GET",
        headers: AuthUtils.getHeaders({ filename: fileName }),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }

  public async uploadAsset(fileName: any, companyId: any, base64Data: any, extension: any) {
    let photo = {
      data: base64Data,
      type: `image/${extension}`,
      fileName: fileName,
      companyId: companyId
    };
    let body = { photo: photo };
    try {
      let response = await fetch(`${BASE_URL}/assets/add`, {
        method: "POST",
        headers: AuthUtils.getHeaders(),
        body: JSON.stringify(body),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }

  public async deleteAsset(objectId: any) {
    try {
      let response = await fetch(`${BASE_URL}/assets/delete/${objectId}`, {
        method: "DELETE",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e) {
      console.log(e);
    }
  }

}
